import { render, staticRenderFns } from "./WasteMerchantFormProgramsPartnerships.vue?vue&type=template&id=46c3ef70&scoped=true&"
import script from "./WasteMerchantFormProgramsPartnerships.vue?vue&type=script&lang=js&"
export * from "./WasteMerchantFormProgramsPartnerships.vue?vue&type=script&lang=js&"
import style0 from "./WasteMerchantFormProgramsPartnerships.vue?vue&type=style&index=0&id=46c3ef70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3ef70",
  null
  
)

export default component.exports